import type { Banner } from '../../../model';
export interface BannerResponse {
  banners: Banner[];
}

export interface GetBannersRequest {
  active?: boolean;
  fromDate?: string;
  toDate?: string;
  location: string;
  limit?: number;
}
